var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Particles'),_c('div',{staticClass:"content"},[_c('img',{attrs:{"alt":"Vue logo","src":require("./assets/logo.svg")}}),_c('Message')],1),_c('Foot')],1)}
var staticRenderFns = []

export { render, staticRenderFns }